var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.109 6C7.497 6 7 6.497 7 7.109v11.09a1.109 1.109 0 1 0 2.218 0v-3.882l5.767 4.325c1.584 1.188 3.844.058 3.844-1.922V8.588c0-1.98-2.26-3.11-3.844-1.923L9.218 10.99V7.11C9.218 6.497 8.72 6 8.109 6Z",
    fill: "#fff"
  })));
};
export default SvgReset;